import { validateRules } from '@foradevelopment/fora-ui';

import { typedT } from '../../../i18n/i18n';
import { isSameOrAfterDate } from './helpers/isSameOrAfterDate';

export const validateEmploymentPeriodEndDate = (employmentStartDate: string) => (value: string) => {
  const rules = [];

  if (value !== '') {
    rules.push(
      isSameOrAfterDate(
        typedT('errorMessages.validation.employmentEndDate3', {
          employmentStartDate: employmentStartDate,
        }),
        employmentStartDate
      )
    );
  }

  return validateRules(rules, value);
};
